<template>
  <b-card>

    <b-form class="m-2">
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Zona *" label-for="cfeZona" >
            <v-select input-id="cfeZona" :options="listZones" :clearable="false" v-model="selectedZone" v-if="listZones"/>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Cuadrilla *" label-for="cfeTeam" >
            <v-select input-id="cfeTeam" :options="listTeams" :clearable="false" v-model="selectedTeam" v-if="listTeams"/>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label="Número *" label-for="number">
            <b-form-input id="number" v-model="project.number" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label="Proyecto *" label-for="name">
            <b-form-input id="name" v-model="project.name" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <div>
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">{{$t('Labels.Save')}}</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">{{$t('Labels.Cancel')}}</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
} from 'bootstrap-vue'

import request from '@/libs/request/index'
import { app } from '@/main'
import { empty } from '@/libs/tools/helpers'
import vSelect from 'vue-select'
import store from '@/store'

const divisionUuid = store.state.session.AppActiveUser().division.uuid

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, vSelect, BFormGroup, BFormInput
  },
  data () {
    return {
      listZones: [{ title: '', value: '', label: '' }],
      listTeams: [{ title: '', value: '', label: '' }],
      selectedZone: {},
      selectedTeam: {},
      project: {
        zoneUuid: '',
        teamUuid: '',
        name: '',
        number: ''
      }
    }
  },
  methods: {
    cancel () {
      this.project.zoneUuid = ''
      this.project.teamUuid = ''
      this.project.name = ''
      this.project.number = ''
      app.$router.push('/projects/')
    },
    async getZones () {
      const params = {
        url: '/zones',
        method: 'GET',
        params: { divisionUuid }
      }
      await request(params).then(data => {
        if (data.status === 200) {
          for (const item of data.data) {
            this.listZones.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    async getTeams () {
      const params = {
        url: '/teams/list/all',
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          for (const item of data.data.data) {
            this.listTeams.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    validateEmpty () {
      if (empty(this.project.name) || empty(this.project.number) || empty(this.selectedTeam.value) || empty(this.selectedZone.value)) {
        this.$swal({
          title: this.$t('Messages.Fail'),
          text: this.$t('Messages.MissingParams'),
          icon: 'error'
        })
        return true
      }
    },
    async save () {
      if (!this.validateEmpty()) {
        this.project.zoneUuid = this.selectedZone.value
        this.project.teamUuid = this.selectedTeam.value

        const params = {
          url: '/projects',
          method: 'POST',
          params: this.project
        }
        await request(params).then(data => {
          app.$router.push('/projects')
        }).catch(err => {
          const errMsg = err?.response?.data?.error || err?.response?.data?.msg
          if (errMsg) {
            this.$swal({
              title: 'Error',
              text: errMsg,
              timer: 5000,
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-warning'
              },
              buttonsStyling: false
            })
          }
        })
      }
    }
  },
  created () {
    this.getZones()
    this.getTeams()
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
